import { render, staticRenderFns } from "./Chevrons.vue?vue&type=template&id=63acb55a&scoped=true&lang=html"
import script from "./Chevrons.vue?vue&type=script&lang=js"
export * from "./Chevrons.vue?vue&type=script&lang=js"
import style0 from "./Chevrons.vue?vue&type=style&index=0&id=63acb55a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63acb55a",
  null
  
)

export default component.exports